import messages from './shell.json' with { type: 'json' };

export const shellSv: Readonly<typeof messages> = messages;
